import React from "react";
import DiscountIcon from "../../../images/Discount.png";
import { PanierDiscount } from "../../../interfaces/loyality.interface";
import "./LoyaltyDiscount.scss";
/**
 * LoyaltyDiscount component description.
 *
 * @LoyaltyDiscount
 *
 */

interface LoyaltyDiscountProps {
  panierDiscount: PanierDiscount;
  isPanierDiscountApplied: boolean;
  isPanierDiscountDisabled: boolean;
  onApplyDiscount: () => void;
  onCancelDiscount: () => void;
}

const LoyaltyDiscount: React.FC<LoyaltyDiscountProps> = ({
  panierDiscount,
  isPanierDiscountApplied,
  isPanierDiscountDisabled,
  onApplyDiscount,
  onCancelDiscount,
}) => {
  const remiseMessage =
    panierDiscount?.cartRewardDiscountType === 0
      ? `${panierDiscount?.cartRewardDiscountValue}%`
      : `${panierDiscount?.cartRewardDiscountValue?.toFixed(2)} €`;

  const message = `Voulez-vous bénéficier d’une réduction de ${remiseMessage} contre ${panierDiscount?.cartRewardTotalPtRequired} points de fidélité ?`;

  const minPanierMessage = panierDiscount?.cartRewardThresholdMin
    ? `Le montant minimum du panier requis pour bénéficier de cette réduction est de ${panierDiscount.cartRewardThresholdMin}€.`
    : "";

  return (
    <div className="LoyaltyDiscount">
      <div className="header">
        <div className="GiftIcon">
          <img src={DiscountIcon} alt="" />
        </div>
        {/* <h1>Bravo !</h1> */}
        <p>{message}</p>
      </div>

      <div className="footer">
        {isPanierDiscountApplied ? (
          <button className="cancel-btn" onClick={onCancelDiscount}>
            Annuler
          </button>
        ) : (
          <button
            onClick={onApplyDiscount}
            className={`submit-btn ${isPanierDiscountDisabled ? "disabled" : ""}`}
            disabled={isPanierDiscountDisabled}
          >
            Appliquer la remise
          </button>
        )}
      </div>
      {minPanierMessage && (
        <p className="min-panier-message">{minPanierMessage}</p>
      )}
    </div>
  );
};

export default LoyaltyDiscount;
